module.exports = __webpack_public_path__ + "img/appicon_full.9a7448e0.png";